/* eslint-disable @next/next/no-img-element */
import React from "react";
import styles from "./styles.module.scss";

export default function TeamValueSection({ windowSize }) {
  const texts = [
    {
      title: "Commitment",
      content:
        "We put Seekho before self and have a purpose beyond personal success",
    },
    {
      title: "Ownership",
      content:
        "We are lean and flat, so we own our stuff and get it done. You push, we back you",
    },
    {
      title: "Performance",
      content:
        "We shoot for greatness and excel in performance. There is no room for mediocrity ",
    },
  ];

  return (
    <div className={styles.teams_values_wrapper}>
      <div className={styles.team_title}>
        <h2>
          What we <span>value</span>
        </h2>
      </div>
      <div className={styles.team_value_list}>
        {texts?.map((data) => (
          <div key={data.title} className={styles.card_value}>
            <div className={styles.card_content}>{data.content}</div>
            <div className={styles.card_title}>{data.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
